import { render, staticRenderFns } from "./WebshopReceipt.vue?vue&type=template&id=155ce144&scoped=true&"
import script from "./WebshopReceipt.vue?vue&type=script&lang=js&"
export * from "./WebshopReceipt.vue?vue&type=script&lang=js&"
import style0 from "./WebshopReceipt.vue?vue&type=style&index=0&id=155ce144&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155ce144",
  null
  
)

export default component.exports